function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "className",
    "aria-label"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import { styled } from '@mui/system';
import { forwardRef } from '@mui/x-internals/forwardRef';
import { isOverflown } from "../../utils/domUtils.js";
import { getDataGridUtilityClass } from "../../constants/gridClasses.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
var GridColumnHeaderTitleRoot = styled('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle',
    overridesResolver: function(props, styles) {
        return styles.columnHeaderTitle;
    }
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)',
    lineHeight: 'normal'
});
var ColumnHeaderInnerTitle = forwardRef(function ColumnHeaderInnerTitle(props, ref) {
    // Tooltip adds aria-label to the props, which is not needed since the children prop is a string
    // See https://github.com/mui/mui-x/pull/14482
    var className = props.className, other = _objectWithoutPropertiesLoose(props, _excluded);
    var rootProps = useGridRootProps();
    var classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ _jsx(GridColumnHeaderTitleRoot, _extends({
        className: clsx(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function GridColumnHeaderTitle(props) {
    var _rootProps_slotProps;
    var label = props.label, description = props.description;
    var rootProps = useGridRootProps();
    var titleRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(''), 2), tooltip = _React_useState[0], setTooltip = _React_useState[1];
    var handleMouseOver = React.useCallback(function() {
        if (!description && (titleRef === null || titleRef === void 0 ? void 0 : titleRef.current)) {
            var isOver = isOverflown(titleRef.current);
            if (isOver) {
                setTooltip(label);
            } else {
                setTooltip('');
            }
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ _jsx(rootProps.slots.baseTooltip, _extends({
        title: description || tooltip
    }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseTooltip, {
        children: /*#__PURE__*/ _jsx(ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}
process.env.NODE_ENV !== "production" ? GridColumnHeaderTitle.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    columnWidth: PropTypes.number.isRequired,
    description: PropTypes.node,
    label: PropTypes.string.isRequired
} : void 0;
export { GridColumnHeaderTitle };
